(() => {
  const mobile = window.matchMedia('(max-width: 749px)');

  const initFooter = (root = document) => {
    root.querySelectorAll('[data-bs-footer-group]').forEach((group) => {
      if (group.dataset.bsMobileReady) return;
      const toggle = group.querySelector('[data-bs-footer-toggle]');
      const links = group.querySelector('[data-bs-footer-links]');
      if (!toggle || !links) return;
      group.dataset.bsMobileReady = 'true';
      const setOpen = (open) => {
        if (!open && links.contains(document.activeElement)) toggle.focus();
        toggle.setAttribute('aria-expanded', String(open));
        links.hidden = !open;
      };
      const updateLayout = () => {
        toggle.tabIndex = mobile.matches ? 0 : -1;
        setOpen(!mobile.matches || group.hasAttribute('data-bs-footer-default-open'));
      };
      toggle.addEventListener('click', () => {
        if (mobile.matches) setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });
      mobile.addEventListener('change', updateLayout);
      updateLayout();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFooter(), { once: true });
  } else {
    initFooter();
  }
  document.addEventListener('shopify:section:load', (event) => initFooter(event.target));
})();
